import React, { useState, useEffect } from 'react';
import '../../styles/Validation.css';
import Navbar from '../../pages/Navbar';
import api from "../../api";
import { fetchUserId, fetchCompanyId } from '../../helpers/CompanyId';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Button,
} from '@mui/material';

import * as XLSX from 'xlsx';

const PayCalculationTable = () => {
  const [months, setMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [payCalculations, setPayCalculations] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [error, setError] = useState(null);
  const [payrollSettings, setPayrollSettings] = useState(null);


  // Fetch the companyId on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userId = await fetchUserId();
        // const role = await fetchRole();
        if (userId) {
          const companyId = await fetchCompanyId(userId);
          if (companyId) {
            setCompanyId(companyId); // Set companyId in state
          } else {
            console.error("Failed to fetch companyId.");
          }
        } else {
          console.error("Failed to fetch userId.");
        }
      } catch (error) {
        console.error("Error fetching user or company data:", error);
      }
    };
    fetchData();
  }, []);

  // Fetch unique month values on component mount
  useEffect(() => {
    const fetchMonths = async () => {
      try {
        const response = await api.get('/api/paycalculation/unique-months/', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access')}`, // Add token dynamically
          },
        });
        setMonths(response.data); // Update state with API response
      } catch (error) {
        console.error('Error fetching unique months:', error.response?.data || error.message);
      }
    };
  fetchMonths();
}, []);

// Fetch data for the selected month
const fetchPayCalculations = async () => {
  try {
    const response = await api.get('/api/paycalculation/by-month/', {
      params: { month: selectedMonth, company_id: companyId }
    });
    setPayCalculations(response.data);
  } catch (error) {
    console.error('Error fetching pay calculations:', error);
  }
};

useEffect(() => {
  const fetchPayrollSettings = async () => {
    try {
      const userId = await fetchUserId(); // Fetch userId using helper function
      console.log("UID:", userId);
      if (!userId) {
        setError('User ID not found');
        return;
      }

      const companyId = await fetchCompanyId(userId); // Fetch companyId using helper function
      console.log("UUUID:", companyId); // Fixed incorrect log

      console.log("COMID:", companyId);
      if (!companyId) {
        setError('Company ID not found');
        return;
      }

      const url = `/api/payroll-settings/${companyId}/`; 
      const response = await api.get(url);
      setPayrollSettings(response.data); // Store payroll settings in state
      // console.log("Payroll settings:", response.data); // Optional: log the fetched data

    } catch (error) {
      console.error('Error fetching payroll settings:', error.response?.data || error.message);
    }
  };

  fetchPayrollSettings(); // Correct function call
}, []);

if (!payrollSettings) {
  return <p>Loading...</p>; // Show a loading state while fetching data
}

// Destructure required flags
const { da_enabled, esi, lwf } = payrollSettings;

const downloadExcel = () => {
  if (payCalculations.length === 0 || !payrollSettings) return;

  // Base column order (without optional fields)
  let columnOrder = [
    "empId", "name", "month", "no_of_days", "attendance", "lop_days", "OT",
    "salary", "basic", "hra", "special_allowance", "grossPay", "otPay",
    "allowance", "totalPay", "eePF", "pt", "deductiblesLoans",
    "deductions", "totalDeductions", "net_pay"
  ];

  // Include conditional fields based on payroll settings
  if (payrollSettings.da_enabled) columnOrder.splice(10, 0, "da");  // Insert DA after HRA
  if (payrollSettings.esi) columnOrder.splice(columnOrder.indexOf("eePF") + 1, 0, "esi"); // After PF
  if (payrollSettings.lwf) columnOrder.splice(columnOrder.indexOf("esi") + 1, 0, "lwf"); // After ESI

  // Proper case column headers mapping
  const columnHeaders = {
    empId: "Emp ID",
    name: "Name",
    month: "Month",
    no_of_days: "No of Days",
    attendance: "Attendance",
    lop_days: "LOP Days",
    OT: "OT",
    salary: "Salary",
    basic: "Basic",
    hra: "HRA",
    da: "DA",
    special_allowance: "Special Allowance",
    grossPay: "Gross Pay",
    otPay: "OT Pay",
    allowance: "Allowance",
    totalPay: "Total Pay",
    eePF: "Employee PF",
    esi: "ESI",
    lwf: "LWF",
    pt: "PT",
    deductiblesLoans: "Deductibles/Loans",
    deductions: "Deductions",
    totalDeductions: "Total Deductions",
    net_pay: "Net Pay"
  };

  // Format the data by removing unwanted columns
  const formattedData = payCalculations.map(row => {
    const newRow = {};
    columnOrder.forEach(col => {
      newRow[columnHeaders[col]] = row[col]; // Rename column headers
    });
    return newRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Set column headers in proper case
  XLSX.utils.sheet_add_aoa(worksheet, [columnOrder.map(col => columnHeaders[col])], { origin: "A1" });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "PayCalculations");
  XLSX.writeFile(workbook, `Pay_Calculations_${selectedMonth}.xlsx`);
};




  return (
    <div>
        <Navbar />
        <div style={{ padding: '20px' }}>
        <h2>Pay Calculation Data</h2>

        {/* Dropdown to select month */}
        <Select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            displayEmpty
            style={{ marginRight:'10px', marginBottom: '10px', minWidth: '120px', height: '35px'}}
        >
            <MenuItem value="" disabled>Select Month</MenuItem>
            {months.map((month, index) => (
            <MenuItem key={index} value={month}>
                {month}
            </MenuItem>
            ))}
        </Select>

        {/* Button to trigger data fetch */}
        <Button  
variant="contained" color="primary" onClick={fetchPayCalculations} disabled={!selectedMonth}>
            Submit
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={downloadExcel}
          disabled={payCalculations.length === 0}
          style={{ marginLeft: '10px' }}
        >
          Download Excel
        </Button>

        <TableContainer component={Paper} style={{ marginTop: '20px', maxHeight: '400px' }}>

            <Table stickyHeader>
            <TableHead>
                <TableRow>
                <TableCell>EMP ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Month</TableCell>
                <TableCell>No of Days</TableCell>
                <TableCell>Attendance</TableCell>
                <TableCell>LOP Days</TableCell>
                <TableCell>OT</TableCell>
                <TableCell>Salary</TableCell>
                <TableCell>Basic</TableCell>
                <TableCell>HRA</TableCell>
                {da_enabled && <TableCell>DA</TableCell>}
                <TableCell>Special Allowance</TableCell>
                <TableCell>Gross Pay</TableCell>
                <TableCell>OT Pay</TableCell>
                <TableCell>Allowance</TableCell>
                <TableCell>Total Pay</TableCell>
                <TableCell>eePF</TableCell>
                {esi && <TableCell>ESI</TableCell>}
                {lwf && <TableCell>LWF</TableCell>}
                <TableCell>PT</TableCell>
                <TableCell>Deductibles/Loans</TableCell>
                <TableCell>Deductions</TableCell>
                <TableCell>Net Pay</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {payCalculations.map((row, index) => (
                <TableRow key={index}>
                    <TableCell>{row.empId}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.month}</TableCell>
                    <TableCell>{row.no_of_days}</TableCell>
                    <TableCell>{row.attendance}</TableCell>
                    <TableCell>{row.lop_days}</TableCell>
                    <TableCell>{row.OT}</TableCell>
                    <TableCell>{row.salary}</TableCell>
                    <TableCell>{row.basic}</TableCell>
                    <TableCell>{row.hra}</TableCell>
                    {da_enabled && <TableCell>{row.da}</TableCell>}
                    <TableCell>{row.special_allowance}</TableCell>
                    <TableCell>{row.grossPay}</TableCell>
                    <TableCell>{row.otPay}</TableCell>
                    <TableCell>{row.allowance}</TableCell>
                    <TableCell>{row.totalPay}</TableCell>
                    <TableCell>{row.eePF}</TableCell>
                    {esi && <TableCell>{row.esi}</TableCell>}
                    {lwf && <TableCell>{row.lwf}</TableCell>}
                    <TableCell>{row.pt}</TableCell>
                    <TableCell>{row.deductiblesLoans}</TableCell>
                    <TableCell>{row.deductions}</TableCell>
                    <TableCell>{row.net_pay}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        </div>
    </div>
  );
};

export default PayCalculationTable;
